/**
 * Created by superman on 17/2/16.
 * http配置
 */

import axios from 'axios'
import store from '../store/index'
import * as types from '../store/types'
import router from '../router/index'
import Qs from 'qs'

// axios 配置
axios.defaults.timeout = 5000;
axios.defaults.baseURL = types.API_URL;
axios.defaults.responseType= 'json';
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['Access-Control-Allow-Origin'] ='*';


axios.defaults.transformRequest = [function (data) {
  // 这里可以在发送请求之前对请求数据做处理，比如form-data格式化等，这里可以使用开头引入的Qs（这个模块在安装axios的时候就已经安装了，不需要另外安装）
  data = Qs.stringify(data);
  return data;
}];
axios.defaults.data={_t: '1'};
axios.defaults.transformResponse = [function (data) {
  // 这里提前处理返回的数
  return data;
}];
axios.defaults.onUploadProgress= [function(progressEvent) {}];
axios.defaults.onDownloadProgress= [function(progressEvent) {}];

// http request 拦截器
axios.interceptors.request.use(
  config => {
    config.headers.req_type = 'ajax';
    config.headers={'Content-Type': 'application/x-www-form-urlencoded'};
    if (store.state.token) {
      config.headers.Authorization = `${store.state.common.token}`;
    }
    return config;
  },
  err => {
    //console.log(JSON.stringify(err));
    return Promise.reject(err);
  });

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    //alert(JSON.stringify(error));
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          store.commit(types.LOGOUT);
          router.replace({
            path: 'login',
            query: {redirect: router.currentRoute.fullPath}
          })
      }
    }
    //console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
    try{
      return Promise.reject(error.response.data)
    }catch(e){}

  });



export default axios;



// WEBPACK FOOTER //
// ./src/api/http.js